export const articleStatic = {
  crumbs_nav: [
    { title_ua: 'Головна', title_ru: 'Главная', link: '/' },
    { title_ua: 'Блог', title_ru: 'Блог', link: '/blog/' },
  ],
};
